import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 400 400\" id=\"icon-user\">\n<style type=\"text/css\">\n\t#icon-user .st0{fill:#2174ff;}\n</style>\n<g id=\"icon-user_admin.psd\">\n\t<g id=\"icon-user__x2D_s-admin_icon\">\n\t\t<path class=\"st0\" d=\"M200,222.2c-57.7,0-104.6-47-104.6-104.9S142.3,12.5,200,12.5c57.7,0,104.6,47,104.6,104.9\n\t\t\tS257.7,222.2,200,222.2z M200,39.6c-42.7,0-77.5,34.9-77.5,77.8s34.8,77.8,77.5,77.8s77.5-34.9,77.5-77.8S242.7,39.6,200,39.6z\" />\n\t\t<path class=\"st0\" d=\"M348,387.5c-7.5,0-13.5-6.1-13.5-13.5c0-74.1-60.3-134.4-134.4-134.4S65.6,299.9,65.6,374\n\t\t\tc0,7.5-6.1,13.5-13.5,13.5s-13.5-6.1-13.5-13.5c0-89,72.4-161.4,161.5-161.4c89.1,0,161.5,72.4,161.5,161.4\n\t\t\tC361.5,381.4,355.4,387.5,348,387.5z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user.svg
// module id = VdD3
// module chunks = 35